<!--
  Clickable table row: every `RowLinkCell` inside links to `to`.
  Safari < 26 ignores `position: relative` on <tr>, so the overlay links live in the cells.
-->
<template>
  <tr>
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { provide, toRef } from "vue";
import type { RouteLocationRaw } from "vue-router";
import { rowLinkToKey } from "./rowLink";

const props = defineProps<{
  to: RouteLocationRaw;
}>();

provide(rowLinkToKey, toRef(props, "to"));
</script>
